import { render, staticRenderFns } from "./GroupPeopleIcon.vue?vue&type=template&id=1ce50362&"
import script from "./GroupPeopleIcon.vue?vue&type=script&lang=ts&"
export * from "./GroupPeopleIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports